import { Component, EventEmitter, Inject, OnInit, Output, ViewChild } from '@angular/core';
import { DateFilterFn } from '@angular/material/datepicker';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import * as moment from 'moment';
import { ServiceData, UserProfileData, PaginationArgs, DailyAvailabilityArgs, AdministrationResultStatus, AddBookingData, TermData, RetrieveGeneratedTimeSlotsData, BookedTermData, TermDataListAdministrationResult, HolidayData, AvailabilityStatusEnum } from 'src/app/clients/system-api/SystemApiClient';
import { BookingService } from 'src/app/services/booking.service';
import { CalendarRefreshService } from 'src/app/services/calendar.service';
import { EmployeeService } from 'src/app/services/employee.service';
import { HolidayService } from 'src/app/services/holiday.service';
import { ScheduleService } from 'src/app/services/schedule.service';
import { ServiceService } from 'src/app/services/service.service';
import { SnackBarService } from 'src/app/services/snack-bar.service';
import { TermService } from 'src/app/services/term.service';
import { WindowDimensions, WindowDimensionsService } from 'src/app/services/window-dimension-service.service';

@Component({
  selector: 'app-term-add-popup',
  templateUrl: './term-add-popup.component.html',
  styleUrls: ['./term-add-popup.component.scss']
})
export class TermAddPopupComponent implements OnInit {
  @Output() close = new EventEmitter<boolean>();

  windowDimensions: WindowDimensions = {} as WindowDimensions;

  notRegistredUser: boolean = false;
  selectedDate: Date | null = null;
  recurringTerm = false;
  showingRecurringTerms: boolean = false;

  serviceData: ServiceData[] | undefined = [];
  employeeData: UserProfileData[] | undefined = [];
  clientsData: UserProfileData[] | undefined = [];

  addBookingData: AddBookingData = new AddBookingData();
  termDataList: TermData[] = [];
  dailyAvailabilityArgsForDays: DailyAvailabilityArgs = new DailyAvailabilityArgs();
  dailyAvailabilityArgs: DailyAvailabilityArgs = new DailyAvailabilityArgs();

  holidayData: HolidayData[] | undefined = [];
  termHourlyData: any[] | undefined = [];
  numberOfDays: number[] = []

  hourSelection: Date = new Date()
  yesterday = new Date();

  holidayDate = new Date();

  daysMultiplier: number = 1; daysNumber: number = 1;
  numberOfAppointments: number = 2; clientProfileId: number | undefined; retrieveAvailability: any;

  constructor(public serviceService: ServiceService,
    public employeeService: EmployeeService,
    public scheduleService: ScheduleService,
    public termService: TermService,
    public bookingService: BookingService,
    private _snackBarService: SnackBarService,
    private calendarRefreshService: CalendarRefreshService,
    private holidayService: HolidayService,
    private router: Router,
    private translateService: TranslateService,
    private _windowDimensionService: WindowDimensionsService
  ) {
    this._windowDimensionService.getWindowDimensions$().subscribe((dimensions) => {
      this.windowDimensions = dimensions;
    });

    this.yesterday.setDate(this.yesterday.getDate() - 0);
  }

  ngOnInit(): void {
    var paginationArgs = new PaginationArgs();
    paginationArgs.skipCount = 0;
    paginationArgs.maxResultCount = 9999;
    paginationArgs.sorting = 'Id ASC';

    this.serviceService.retrieveAllServices(paginationArgs).subscribe((data) => {
      this.serviceData = data.content?.items;
      this.serviceData = this.serviceData?.filter(x => x.active == true);
    });

    this.holidayService.retrieveAllHolidays(paginationArgs).subscribe((data) => {
      this.holidayData = data.content?.items!;
    });

    this.employeeService.retrieveAllUsers(2).subscribe((data) => {
      this.clientsData = data.content?.items;
    });

    for (var i = 1; i <= 50; i++) { this.numberOfDays.push(i); }

    this.addBookingData.termsList = new Array<BookedTermData>()
  }

  retrieveAllEpmloyeeByService() {
    this.employeeService.retrieveAllUsers(3, undefined, this.dailyAvailabilityArgsForDays.serviceId).subscribe((data) => {
      this.employeeData = data.content?.items;
    });
  }

  resetDateTime() {
    this.dailyAvailabilityArgsForDays.startDate = undefined;
    this.hourSelection = new Date();
  }

  retriveHours() {
    var body = new DailyAvailabilityArgs();
    body.employeeProfileId = this.dailyAvailabilityArgsForDays.employeeProfileId;
    body.serviceId = this.dailyAvailabilityArgsForDays.serviceId;
    body.startDate = this.dailyAvailabilityArgsForDays.startDate;
    body.startDate?.setHours(2);

    body.endDate = body.startDate;
    body.hourlyAvailabilityCheck = true;
    body.hourlyAvailabilityCheckLimit = 1;

    this.scheduleService.retrieveAvailability(body).subscribe((data: any) => {

      body.startDate?.setHours(0);
      body.endDate = body.startDate
      const formattedDate = this.formatDatePickerDate(body.startDate!);

      this.termHourlyData = new Array<Date>()
      this.termHourlyData = data.content[formattedDate]?.hourlyAvailability;
    });
  }

  retriveAlternateTermHours(termData: TermData, index: number) {
    termData.fromDate?.setHours(termData.fromDate!.getHours())

    var date = new Date(termData.fromDate!)
    date.setHours(0)
    date.setMinutes(0)
    date.setMilliseconds(0)

    const formattedDate = this.formatDatePickerDate(date);

    var alternateTermHourlyData = new Array<Date>()
    alternateTermHourlyData = this.retrieveAvailability[formattedDate]?.hourlyAvailability;

    var before = alternateTermHourlyData.filter(x => x.getHours() < termData.fromDate!.getHours()
      || (x.getHours() == termData.fromDate!.getHours() && x.getMinutes() < termData.fromDate!.getMinutes())).sort((a, b) => (a > b ? -1 : 1))

    var after = alternateTermHourlyData.filter(x => x.getHours() > termData.fromDate!.getHours()
      || (x.getHours() == termData.fromDate!.getHours() && x.getMinutes() > termData.fromDate!.getMinutes())).sort((a, b) => (a > b ? 1 : -1))

    var termDate1 = new TermData()
    termDate1.fromDate = new Date(formattedDate)

    var termDate2 = new TermData()
    termDate2.fromDate = new Date(formattedDate)

    if (before.length > 0 && after.length > 0) {
      termDate1.fromDate.setHours(before[0].getHours())
      termDate1.fromDate.setMinutes(before[0].getMinutes())

      termDate2.fromDate.setHours(after[0].getHours())
      termDate2.fromDate.setMinutes(after[0].getMinutes())
    }
    else if (before.length > 0 && after.length == 0) {
      termDate1.fromDate.setHours(before[0].getHours())
      termDate1.fromDate.setMinutes(before[0].getMinutes())

      if (before.length > 1) {
        termDate2.fromDate.setHours(before[1].getHours())
        termDate2.fromDate.setMinutes(before[1].getMinutes())
      }
    }
    else if (before.length == 0 && after.length > 0) {
      termDate1.fromDate.setHours(after[0].getHours())
      termDate1.fromDate.setMinutes(after[0].getMinutes())

      if (after.length > 1) {
        termDate2.fromDate.setHours(after[1].getHours())
        termDate2.fromDate.setMinutes(after[1].getMinutes())
      }
    }

    this.termDataList[index].alternativeTermDataList!.push(termDate1)
    this.termDataList[index].alternativeTermDataList!.push(termDate2)
  }

  closePopup() {
    this.close.emit();
  }

  //Disable Sundays
  filterSundays = (d: Date | null): boolean => {
    const day = (d || new Date()).getDay();
    return day !== 0;
  }

  isHoliday: DateFilterFn<Date | null> = (date: Date | null) => {

    const isHoliday = this.holidayData!.some(holiday => {
      const holidayDate = new Date(holiday.date!);
      return date!.getFullYear() === holidayDate.getFullYear() &&
        date!.getMonth() === holidayDate.getMonth() &&
        date!.getDate() === holidayDate.getDate();
    });

    return !isHoliday;
  }

  combinedFilter: DateFilterFn<Date | null> = (date: Date | null) => {
    const isHoliday = this.isHoliday(date);
    return isHoliday;
  }

  formatDatePickerDate(date: Date): string {
    let formattedDate = moment(date).utc(true);
    formattedDate.set({ hour: 0, minute: 0, second: 0, millisecond: 0 });

    return formattedDate.format('YYYY-MM-DDTHH:mm:ss') + "Z";;
  }

  changeRecurring() {
    this.recurringTerm = !this.recurringTerm;
    this.addBookingData.termsList = new Array<BookedTermData>()
  }

  addBooking() {
    if (this.recurringTerm === false) {//Insert the first term
      this.addBookingData.termsList = new Array<BookedTermData>()

      var bookedTermData = new BookedTermData();
      bookedTermData.employeeProfileId = this.dailyAvailabilityArgsForDays.employeeProfileId;

      if (this.dailyAvailabilityArgsForDays.startDate) {
        let fromDate = new Date(this.dailyAvailabilityArgsForDays.startDate);
        fromDate.setHours(this.hourSelection.getHours());
        fromDate.setMinutes(this.hourSelection.getMinutes());
        bookedTermData.fromDate = moment(fromDate).utc(true).toDate();
      }

      this.addBookingData.termsList!.push(bookedTermData)
    }

    if (this.addBookingData.termsList?.length == 0) {
      this._snackBarService.callSnackBar(AdministrationResultStatus.NoTerms, "Successfully entered");
      return;
    }

    this.addBookingData.serviceId = this.dailyAvailabilityArgsForDays.serviceId;
    this.addBookingData.profileId = this.clientProfileId;

    this.addBookingData.termsList?.sort((a: TermData, b: TermData) => {
      return a.fromDate!.getTime() - b.fromDate!.getTime();
    })

    this.bookingService.addBooking(this.addBookingData).subscribe((data) => {
      this._snackBarService.callSnackBar(data, "Successfully entered");
      if (data.status == AdministrationResultStatus.Success) {
        this.calendarRefreshService.triggerRefresh();
        this.close.emit();
      } else {
        this._snackBarService.callSnackBar("Error", "error");
      }
    });
  }

  addTermToBooking(termData: TermData) {
    if (termData.unavailableEmployee == true || termData.unavailableTerm == true) { return; }

    var bookedTermData = new BookedTermData();
    bookedTermData.employeeProfileId = this.dailyAvailabilityArgsForDays.employeeProfileId;
    if (termData && termData.fromDate) {
      bookedTermData.fromDate = moment(new Date(termData.fromDate)).utc(true).toDate();
    }

    var existing = (this.addBookingData.termsList!.filter(x =>
      x.fromDate?.getFullYear() == bookedTermData.fromDate!.getFullYear() &&
      x.fromDate?.getMonth() == bookedTermData.fromDate!.getMonth() &&
      x.fromDate?.getDate() == bookedTermData.fromDate!.getDate() &&
      x.fromDate?.getDay() == bookedTermData.fromDate!.getDay() &&
      x.fromDate?.getHours() == bookedTermData.fromDate!.getHours() &&
      x.fromDate?.getMinutes() == bookedTermData.fromDate!.getMinutes()))

    if (existing.length > 0) {
      var index = this.addBookingData.termsList?.indexOf(existing[0])
      this.addBookingData.termsList?.splice(index!, 1)
    }
    else {
      this.addBookingData.termsList?.push(bookedTermData)
    }
  }

  retrieveGeneratedTimeSlots() {
    this.dailyAvailabilityArgsForDays.startDate?.setHours(this.hourSelection.getHours());
    this.dailyAvailabilityArgsForDays.startDate?.setMinutes(this.hourSelection.getMinutes());
    this.dailyAvailabilityArgsForDays.startDate = moment(this.dailyAvailabilityArgsForDays.startDate).utc(true).toDate();

    this.dailyAvailabilityArgsForDays.endDate = moment(new Date(this.dailyAvailabilityArgsForDays.startDate!)).utc(true).toDate();
    this.dailyAvailabilityArgsForDays.endDate!.setDate(this.dailyAvailabilityArgsForDays.startDate!.getDate() + ((this.numberOfAppointments - 1) * this.daysMultiplier * this.daysNumber))

    this.dailyAvailabilityArgsForDays.hourlyAvailabilityCheck = true
    this.dailyAvailabilityArgsForDays.hourlyAvailabilityCheckLimit = 1000

    this.termDataList = new Array<TermData>()

    this.scheduleService.retrieveAvailability(this.dailyAvailabilityArgsForDays).subscribe((data) => {
      this.retrieveAvailability = data.content
      if (data.status == AdministrationResultStatus.Success) {
        this.showingRecurringTerms = true;
        var date = new Date(this.dailyAvailabilityArgsForDays.startDate!)
        date.setHours(0); date.setMinutes(0); date.setMilliseconds(0);

        let i = 0
        for (let dt = date; dt <= this.dailyAvailabilityArgsForDays.endDate!; dt.setDate(dt.getDate() + 1)) {

          if ((i % (this.daysMultiplier * this.daysNumber)) > 0) {
            //The day has to according to the choices of the user (time between two terms)
            i++; continue;
          }
          i++;

          let day = data.content![this.formatDatePickerDate(dt)]

          let termData = new TermData()
          termData.employeeProfileId = this.dailyAvailabilityArgsForDays.employeeProfileId;
          termData.serviceId = this.dailyAvailabilityArgsForDays.serviceId;
          termData.profileId = this.clientProfileId
          termData.fromDate = moment(dt).utc(true).toDate();
          termData.fromDate.setHours(this.hourSelection.getHours())
          termData.fromDate.setMinutes(this.hourSelection.getMinutes())
          termData.unavailableTerm = false;
          termData.unavailableEmployee = false;

          if (day != undefined) {
            if (day.status == AvailabilityStatusEnum.Available || day.status == AvailabilityStatusEnum.InSchedule) {
              if (day.hourlyAvailability!.length > 0) {//Are there any existing time slots for the day?
                var existingTimeSlot = day.hourlyAvailability?.find(x =>
                  x.getHours() == this.hourSelection.getHours() &&
                  x.getMinutes() == this.hourSelection.getMinutes())
                if (existingTimeSlot == null) {
                  termData.unavailableTerm = true;
                }
              }
              else {
                termData.unavailableTerm = true;
                termData.unavailableEmployee = true;//The employee is unavailable for the whole day, no alternative terms
              }
            }
            else {
              termData.unavailableTerm = true;
              termData.unavailableEmployee = true;
            }
          }
          else {
            termData.unavailableTerm = true;
            termData.unavailableEmployee = true;
          }

          termData.alternativeTermDataList = new Array<TermData>()

          this.termDataList.push(termData)
        }
      }
    });
  }

  public translate(key: string) {
    return this.translateService.instant(key);
  }
}

